export default __webpack_public_path__ + "1a98ab75c2174eacbf7ca21a455e210b.jpg";